// extracted by mini-css-extract-plugin
export var dividerLine = "_88-3";
export var itemImage = "_88-9";
export var lightDivider = "_88-4";
export var modalContent = "_88-5";
export var modalContentCompact = "_88-6";
export var productCard = "_88-a";
export var productImage = "_88-b";
export var productImageCompact = "_88-7";
export var productImagePlaceholder = "_88-c";
export var productImagePlaceholderCompact = "_88-8";
export var progressBarBackground = "_88-1";
export var progressBarContainer = "_88-0";
export var progressBarFill = "_88-2";